import ApiService from './api';

class DepartmentService {
  // Get all active departments
  async getDepartments() {
    try {
      return await ApiService.get('/departments');
    } catch (error) {
      throw error;
    }
  }

  // Get departments with pagination (admin)
  async getDepartmentsPaginated(page = 0, size = 10) {
    try {
      const queryParams = new URLSearchParams({ page, size });
      return await ApiService.get(
        `/departments/paginated?${queryParams.toString()}`
      );
    } catch (error) {
      throw error;
    }
  }

  // Get department by ID
  async getDepartmentById(id) {
    try {
      return await ApiService.get(`/departments/${id}`);
    } catch (error) {
      throw error;
    }
  }

  // Get department by code
  async getDepartmentByCode(code) {
    try {
      return await ApiService.get(`/departments/code/${code}`);
    } catch (error) {
      throw error;
    }
  }

  // Create new department (admin only)
  async createDepartment(departmentData) {
    try {
      return await ApiService.post('/departments', departmentData);
    } catch (error) {
      throw error;
    }
  }

  // Update department (admin only)
  async updateDepartment(id, departmentData) {
    try {
      return await ApiService.put(`/departments/${id}`, departmentData);
    } catch (error) {
      throw error;
    }
  }

  // Delete department (admin only)
  async deleteDepartment(id) {
    try {
      return await ApiService.delete(`/departments/${id}`);
    } catch (error) {
      throw error;
    }
  }

  // Toggle department status (admin only)
  async toggleDepartmentStatus(id) {
    try {
      return await ApiService.patch(`/departments/${id}/toggle-status`);
    } catch (error) {
      throw error;
    }
  }
}

const departmentServiceInstance = new DepartmentService();
export default departmentServiceInstance;
